import { createActionGroup, props } from "@ngrx/store";
import { ContextPanelViews } from "@store/doc-viewer/doc-viewer.state";

export const contextPanelActions = createActionGroup({
	source: 'ContextPanel',
	events: {
		'Set Context Panel': props<{ selectedContext: ContextPanelViews }>(),
	},
});
